module.exports = __webpack_public_path__ + "img/undraw_searching.3bc9a632.svg";